import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import BodyStep from '../../components/BodyStep';
import { useAuth } from '../../contexts/authContext';
import { useSteps } from '../../contexts/stepContext';

const Balcao: React.FC = () => {
  const { changeStep } = useSteps();
  const { verifyToken } = useAuth();
  const params = useParams() as { id: string };
  useEffect(() => {
    verifyToken(params.id);
  }, []);
  return <BodyStep>{changeStep()}</BodyStep>;
};

export default Balcao;
